import { ReactNode } from 'react';
import { useMatch } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Visible } from 'coreOld/components';
import { ITab } from 'coreOld/types';

interface IProps {
  icon?: JSX.Element;
  title: string;
  url?: string;
  onClick: (tab: ITab) => void;
}

type WrapperProps = { children?: ReactNode; onClick?: any };

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

type TabWrapperProps = { selected?: boolean; children?: ReactNode };

export const TabWrapper = styled.a<TabWrapperProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  border-right: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
  font: 400 18px 'Open Sans';
  padding: 15px 1.5vw;
  position: relative;
  width: 100%;
  white-space: nowrap;
  transition: all 0.3s linear;

  ${({ selected }) =>
    selected &&
    css`
      border-bottom: none;
      background-color: ${({ theme }) => theme.palette.backgrounds.main};
    `}

  &:hover {
    background-color: ${({ theme }) => theme.palette.backgrounds.main};
    cursor: pointer;
  }
`;

type IconWrapperProps = { children?: ReactNode };

export const IconWrapper = styled.div<IconWrapperProps>`
  margin-right: 10px;
`;

type TitleProps = { children?: ReactNode };

export const Title = styled.span<TitleProps>``;

const Tab = ({ icon, title, onClick, url }: IProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const isSelected = url ? !!useMatch({ path: url }) : false;

  return (
    <Wrapper onClick={onClick}>
      <TabWrapper selected={isSelected}>
        <Visible when={Boolean(icon)}>
          <IconWrapper>{icon}</IconWrapper>
        </Visible>

        <Title>{title}</Title>
      </TabWrapper>
    </Wrapper>
  );
};

export default Tab;
